export const DEFAULT_STALE_TIME = 1000 * 60 * 5 // 5 minutes
export const STALE_TIME_DAY = 1000 * 60 * 60 * 24 // 24 hours
export const CURRENT_TIME_UPDATE_INTERVAL = 1000 * 60 // 1 minute
export const ONE_DAY_IN_MS = 1000 * 60 * 60 * 24 // Number of milliseconds in one day

export const UNPAGINATED_PAGE_SIZE = 100 // Default page size for unpaginated queries
export const LARGE_UNPAGINATED_PAGE_SIZE = 1000 // Large page size for unpaginated queries
export const CHAT_PAGE_SIZE = 50 // Number of messages to load per page in correspondence chat
export const PAGINATED_PAGE_SIZE = 25 // Default page size for paginated queries
export const MAX_PAGINATED_PAGE_SIZE = 100 // Maximum page size for paginated queries

export const TABLE_PAGE_SIZE = 12 // Default page size for tables
export const LEARNABILITY_SCORE = 12 // Maximum learnability score
export const YEARS_OF_EDUCATION = 30 // Maximum years of education allowed in the system

export const LESSON_INTAKE_REFETCH_INTERVAL = 1000 * 5 // 5 seconds

export const CORRESPONDENCE_MESSAGES_REFETCH_INTERVAL = 1000 * 10 // 10 seconds

export const CORRESPONDENCE_INBOX_REFETCH_INTERVAL = 1000 * 60 // 60 seconds
export const TODO_INBOX_REFETCH_INTERVAL = 1000 * 60 // 60 seconds
export const NOTIFICATION_REFETCH_INTERVAL = 1000 * 60 * 5 // 5 minutes

export const ON_CHANGE_DEBOUNCE_MS = 250 // Default debounce time for form changes

export const PDOK_LOCATIESERVER_BASE_URL =
  "https://api.pdok.nl/bzk/locatieserver/search/v3_1/free"
